import React from 'react';
import { Sheet } from '../../../components/ui';

// A question with three answers (two ways to go ahead, or stop), such as
// "Also cancel future sessions?". The shared confirm only has two, so this
// is the same pop-up with three buttons, the way out last. Labels of about
// 11 characters at most. danger: the first answer is a final delete or
// cancel (solid red, the second red outline).
export default function ChoiceSheet({ title, message, yes, no, cancelLabel = 'Cancel', danger = false, busy = false, onYes, onNo, onCancel, children }) {
  return (
    <Sheet
      title={title}
      onClose={onCancel}
      footer={(
        <div className="bk-actions bk-actions--3">
          <button type="button" className={`bk-btn ${danger ? 'bk-btn--danger' : 'bk-btn--primary'}`} disabled={busy} onClick={onYes}>{yes}</button>
          <button type="button" className={`bk-btn${danger ? ' bk-btn--outline-danger' : ''}`} disabled={busy} onClick={onNo}>{no}</button>
          <button type="button" className="bk-btn" disabled={busy} onClick={onCancel}>{cancelLabel}</button>
        </div>
      )}
    >
      {message && <p className="ui-sheet__message">{message}</p>}
      {children}
    </Sheet>
  );
}
